/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type ContractDocumentKind = typeof ContractDocumentKind[keyof typeof ContractDocumentKind];


export const ContractDocumentKind = {
  contract: 'contract',
  amendment: 'amendment',
  annex: 'annex',
  other: 'other',
} as const;
